// https://litepicker.com/docs/options

const { default: Litepicker } = require("litepicker");

const Datepicker = function () {

    const start = function () {

        let today = new Date().toISOString().slice(0, 10);

        new Litepicker({
            element: document.getElementById('litepicker'),
            singleMode: false,
            maxDate: today,
            // maxDays: 90,
            tooltipText: {
                one: 'dias',
                other: 'dias'
            },
            format: "DD/MM/YYYY",
            firstDay: 0,
            lang: "pt-BR"
        });
    }

    return {
        init: function () {
            if ($('#litepicker').length > 0) {
                start();
            }
        }
    }
}();

module.exports = Datepicker;